import { render, staticRenderFns } from "./MenuTabVariables.vue?vue&type=template&id=30a6e27c&scoped=true"
import script from "./MenuTabVariables.vue?vue&type=script&lang=js"
export * from "./MenuTabVariables.vue?vue&type=script&lang=js"
import style0 from "./MenuTabVariables.vue?vue&type=style&index=0&id=30a6e27c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a6e27c",
  null
  
)

export default component.exports